(function () {
  var MAX_EDGE = 1600;
  var JPEG_QUALITY = 0.72;
  var MAX_SOURCE = 15 * 1024 * 1024;

  function loadImage(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(url);
        resolve(img);
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        reject(new Error('Could not read image'));
      };
      img.src = url;
    });
  }

  function compressImage(file) {
    return loadImage(file).then(function (img) {
      var width = img.naturalWidth || img.width;
      var height = img.naturalHeight || img.height;
      var scale = Math.min(1, MAX_EDGE / Math.max(width, height));
      var canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(width * scale));
      canvas.height = Math.max(1, Math.round(height * scale));
      var ctx = canvas.getContext('2d');
      if (!ctx) throw new Error('Could not process image');
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      return canvas.toDataURL('image/jpeg', JPEG_QUALITY);
    });
  }

  function initUpload(root) {
    var form = root.querySelector('[data-send-photo-form]');
    if (!form || form.getAttribute('data-send-photo-ready') === 'true') return;
    form.setAttribute('data-send-photo-ready', 'true');
    var contactForm = form.tagName === 'FORM' ? form : form.querySelector('form');

    var input = form.querySelector('[data-send-photo-file]');
    var trigger = form.querySelector('[data-send-photo-upload]');
    var label = form.querySelector('[data-send-photo-name]');
    var clearBtn = form.querySelector('[data-send-photo-clear]');
    var errorEl = form.querySelector('[data-send-photo-error]');
    var nameField = form.querySelector('[data-send-photo-filename]');
    var dataField = form.querySelector('[data-send-photo-data]');
    var sendBtn = form.querySelector('[data-send-photo-send]');
    var compressing = false;

    if (!input || !trigger || !label || !clearBtn || !nameField || !dataField) return;

    function setError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
    }

    function clearFile() {
      input.value = '';
      nameField.value = '';
      dataField.value = '';
      label.textContent = '';
      form.classList.remove('is-ready');
      compressing = false;
      if (sendBtn) sendBtn.disabled = false;
      setError('');
    }

    trigger.addEventListener('click', function () {
      input.click();
    });

    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      setError('');

      if (!file) {
        clearFile();
        return;
      }

      if (!file.type || file.type.indexOf('image/') !== 0) {
        clearFile();
        setError('Please choose a photo.');
        return;
      }

      if (file.size > MAX_SOURCE) {
        clearFile();
        setError('That photo is too large. Please choose a smaller image.');
        return;
      }

      compressing = true;
      if (sendBtn) sendBtn.disabled = true;
      label.textContent = 'Preparing photo…';
      form.classList.add('is-ready');

      compressImage(file)
        .then(function (dataUrl) {
          nameField.value = file.name;
          dataField.value = dataUrl;
          label.textContent = file.name;
          if (sendBtn) sendBtn.disabled = false;
        })
        .catch(function () {
          clearFile();
          setError('Could not use that photo. Please try another image.');
        })
        .then(function () {
          compressing = false;
        });
    });

    clearBtn.addEventListener('click', function () {
      clearFile();
      trigger.focus();
    });

    if (contactForm) {
      contactForm.addEventListener('submit', function (event) {
        if (compressing || !dataField.value) {
          event.preventDefault();
          setError(compressing ? 'Please wait for the photo to finish preparing.' : 'Please choose a photo first.');
        }
      });
    }
  }

  function initOverlay(root) {
    var card = root.querySelector('[data-send-photo-card]');
    var overlay = root.querySelector('[data-send-photo-overlay]');
    var openBtn = root.querySelector('[data-send-photo-open]');
    var grid = root.querySelector('[data-send-photo-grid]');
    if (!card || !overlay || !openBtn || card.getAttribute('data-send-photo-overlay-ready') === 'true') return;
    card.setAttribute('data-send-photo-overlay-ready', 'true');

    var closers = overlay.querySelectorAll('[data-send-photo-close]');
    var lastFocus = openBtn;

    function onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeOverlay();
        return;
      }

      if (event.key !== 'Tab' || overlay.hidden) return;
      var focusable = overlay.querySelectorAll('button, [href], input, textarea, select, [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function openOverlay() {
      lastFocus = document.activeElement || openBtn;
      overlay.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      if (grid) grid.setAttribute('aria-hidden', 'true');
      if (grid && 'inert' in grid) grid.inert = true;
      document.addEventListener('keydown', onKeydown);
      var dismiss = overlay.querySelector('[data-send-photo-close]');
      if (dismiss) dismiss.focus();
    }

    function closeOverlay() {
      if (overlay.hidden) return;
      overlay.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      if (grid) grid.removeAttribute('aria-hidden');
      if (grid && 'inert' in grid) grid.inert = false;
      document.removeEventListener('keydown', onKeydown);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    openBtn.addEventListener('click', openOverlay);
    closers.forEach(function (button) {
      button.addEventListener('click', closeOverlay);
    });
  }

  function init(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-section-type="send-photo"]').forEach(function (root) {
      initUpload(root);
      initOverlay(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    init(event.target);
  });
})();
